import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { API } from "../conf";
import { useContext, useState } from "react";
import { Context } from "../App";

export default function Sms(props) {
    const {updateConnect} = useContext(Context)
    const [to, setTo] = useState('')
    const [message, setMessage] = useState('')

    function sendSMS(){
        props.setLoad(true)
        fetch(API.concat('/sendsms'), {method:'POST', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }, body:JSON.stringify({to, message})}).then(async response=>{  
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    console.log(json)
                    props.close()
                }props.setLoad(false)
            }
        })
    }

    return (
        <Stack direction='column' spacing={2} sx={{padding:2}}>
            <Typography variant="h3" align="center">Envoie de SMS</Typography>
            <TextField multiline rows={4} label="Destinataire" value={to} onChange={e=>setTo(e.target.value)} fullWidth/>
            <TextField multiline rows={4} label="Message" value={message} onChange={e=>setMessage(e.target.value)} fullWidth/>
            <Button variant="contained" sx={{alignSelf:'center'}} onClick={sendSMS}>Envoyer</Button>
        </Stack>
    )
}